import styled from 'styled-components';
import { Typography, Collapse, Button } from 'antd';
import { DefaultTheme } from 'styled-components';

const { Title, Text } = Typography;

declare module 'styled-components' {
  export interface DefaultTheme {
    mode?: 'light' | 'dark';
  }
}

const getThemeValue = <T,>(props: { theme?: DefaultTheme }, darkValue: T, lightValue: T): T => {
  return props.theme?.mode === 'dark' ? darkValue : lightValue;
};

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  width: 100%;
`;

export const PageTitle = styled(Title)`
  margin-bottom: 16px !important;
  color: ${props => getThemeValue(props, '#ffffff', '#262626')} !important;
`;

export const TilesContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 16px;
`;

export const StatButton = styled.button<{ isSelected: boolean; theme?: DefaultTheme }>`
  flex: 1;
  min-width: 200px;
  padding: 16px;
  margin: 8px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  background-color: ${props =>
    props.isSelected ? getThemeValue(props, '#4a5568', '#e6f4ff')
      : getThemeValue(props, '#2d3748', '#f5f5f5')} !important;
  box-shadow: ${props =>
    props.isSelected ? getThemeValue(props,'0 4px 6px rgba(0, 0, 0, 0.3)','0 2px 4px rgba(0, 0, 0, 0.1)')
      : getThemeValue(props,'0 2px 4px rgba(0, 0, 0, 0.2)','0 1px 2px rgba(0, 0, 0, 0.05)')} !important;

  &:hover {
    background-color: ${(props)     => getThemeValue(props, '#4a5568', '#e6f4ff')} !important;
    transform: translateY(-1px);
    box-shadow: ${props => getThemeValue(props, '0 6px 12px rgba(0, 0, 0, 0.4)', '0 4px 8px rgba(0, 0, 0, 0.15)')} !important;
  }
`;

export const StatLabel = styled(Text)`
  font-size: 20px !important;
  font-weight: 600 !important;
  display: block !important;
  margin-bottom: 8px !important;
  color: ${props => getThemeValue(props, '#ffffff', '#262626')} !important;
`;

export const StatValue = styled(Text)`
  font-size: 18px !important;
  display: block !important;
  color: ${props => getThemeValue(props, '#a0aec0', '#718096')} !important;
`;

export const DetailsContainer = styled.div`
  margin-top: 16px;
`;

export const StyledCollapse = styled(Collapse)`
  background: ${props => getThemeValue(props, '#1a202c', '#ffffff')} !important;
  border: 1px solid ${props => getThemeValue(props, '#4a5568', '#e5e7eb')} !important;
  border-radius: 6px !important;
  margin-bottom: 16px !important;

  .ant-collapse-item {
    border-bottom: 1px solid ${props => getThemeValue(props, '#4a5568', '#e5e7eb')} !important;

    &:last-child {
      border-bottom: none !important;
    }
  }

  .ant-collapse-header {
    background: ${props => getThemeValue(props, '#1a202c', '#ffffff')} !important;
    color: ${props => getThemeValue(props, '#ffffff', '#262626')} !important;
    padding: 16px !important;
  }

  .ant-collapse-content {
    background: ${props => getThemeValue(props, '#1a202c', '#ffffff')} !important;
    border-top: 1px solid ${props => getThemeValue(props, '#4a5568', '#e5e7eb')} !important;
  }

  .ant-collapse-content-box {
    padding: 16px !important;
  }
`;

export const DetailHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

export const DetailTitle = styled(Title)`
  font-size: 18px !important;
  margin: 0 !important;
  color: ${props => getThemeValue(props, '#ffffff', '#262626')} !important;
`;

export const CloseButton = styled(Button)`
  min-width: auto !important;
  padding: 4px 8px !important;
  border: none !important;
  background: transparent !important;
  color: ${props => getThemeValue(props, '#a0aec0', '#8c8c8c')} !important;

  &:hover {
    background: ${props => getThemeValue(props, '#4a5568', '#f5f5f5')} !important;
    color: ${props => getThemeValue(props, '#ffffff', '#262626')} !important;
  }
`;

export const DetailText = styled(Text)`
  color: ${props => getThemeValue(props, '#a0aec0', '#718096')} !important;
  display: block !important;
`;
